import * as React from "react";
import { getDeliveryAddressInfo } from "../../DeliveryLocation/user-settings";
import { useSpring, animated } from "@react-spring/web";
import styles from "./cart-footer.module.scss";

interface CartFooterProps {
  children?: React.ReactNode;
}

/**
 * Displays the cart footer.  Only shown in marketplace items.
 * 
 * @param props
 * @returns
 */
const CartFooter: React.FC<CartFooterProps> = (props) => {
  const [locationName, setLocationName] = React.useState<string>("");
  const [isMarketPlace, setIsMarketplace] = React.useState(false);

  React.useEffect(() => {
    const storeInfo = getDeliveryAddressInfo();

    const { LocationName, MarketplaceType } = storeInfo;

    if (MarketplaceType && MarketplaceType.length > 0) {
      setIsMarketplace(true);
      if (LocationName && LocationName.length > 0) {
        setLocationName(LocationName);
      }
    }
  }, []);

  const springs = useSpring({
    from: { y: "100%", opacity: 0 },
    to: { y: "0%", opacity: 1 },
  });

  if (!isMarketPlace) {
    return null;
  }

  return (
    <animated.div className={styles["cart-footer"]} style={{ ...springs }}>
      <a href="/HospitalGroupList.aspx?groupid=119">
        <span
          style={{
            display: isMarketPlace ? `inline-block` : `none`,
            fontSize: `1.2rem`,
          }}
        >
          Pickup Location
        </span>
        <p
          className={
            isMarketPlace
              ? styles.locationSelected
              : styles.noLocationSelected
          }
        >
          {isMarketPlace
            ? locationName
            : `For item availability, select a location`}
        </p>
      </a>
      {props.children}
    </animated.div>
  );
};

export default CartFooter;
